<ng-container>
  <div class="hotspots-summary__loading" *ngIf="loading && !hasData">
    <po-loading-overlay></po-loading-overlay>
  </div>
  <p *ngIf="loadError" class="po-font-text-small">Não foi possível carregar o ranking.</p>
  <p *ngIf="!loading && !loadError && !hasData" class="po-font-text-small">Nenhum fonte com correções neste recorte.</p>

  <ng-container *ngIf="hasData">
    <p class="po-font-text-small po-mb-2">{{ contextLabel }}</p>
    <po-chart
      [p-type]="chartType"
      [p-categories]="categories"
      [p-series]="series"
      [p-options]="chartOptions"
      [p-height]="chartHeight"
      (p-series-click)="onSeriesClick($event)">
    </po-chart>
    <div class="hotspots-summary__footer">
      <po-button p-kind="secondary" p-icon="po-icon po-icon-list" [p-label]="showAllLabel" (p-click)="expand()"></po-button>
    </div>
  </ng-container>

</ng-container>

<po-modal #rankingModal p-title="Ranking de fontes que exigem atenção" p-size="xl" p-click-out="true"
  [p-primary-action]="closeAction" (p-close)="expanded = false">
  <app-review-stats-hotspots *ngIf="expanded" [filters]="filters"
    (findingsRequested)="showFindings($event)"></app-review-stats-hotspots>
</po-modal>

<!-- Depois do modal do ranking, e não dentro dele: abre por cima e devolve a ele. -->
<app-review-stats-file-findings [filters]="filters" (reviewOpened)="onReviewOpened()"></app-review-stats-file-findings>
